import { render, staticRenderFns } from "./UploadTitleDeed.vue?vue&type=template&id=567fa68c&scoped=true&"
import script from "./UploadTitleDeed.vue?vue&type=script&lang=js&"
export * from "./UploadTitleDeed.vue?vue&type=script&lang=js&"
import style0 from "./UploadTitleDeed.vue?vue&type=style&index=0&id=567fa68c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567fa68c",
  null
  
)

export default component.exports